<!-- js/components/Admin/ProjectEditView.vue -->

<template>
  <div>
    <div style="text-align: right">
      <button type="button" class="link select-all-toggle" @click="toggleAll"><small>{{ toggleLabel }}</small></button>
    </div>
    <section class="checkbox-cloud grid grid-cols-1 md:grid-cols-2 gap-2" :class="{ 'lg:grid-cols-4': columns === 4 }">
      <label v-for="option in options" :key="_optionId(option)" class="flex items-center space-x-2">
        <input
            type="checkbox"
            class="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2"
            :value="_optionId(option)"
            :checked="has(option)"
            @click="toggle(option)" />
        <span class="font-normal text-cal-4A4A4A pb-0">{{ _optionName(option) }}</span>
      </label>
    </section>
  </div>
</template>

<script>

export default {
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
        value: {
          default () {
            return []
          }
        },
        optionId: {
            default: "id"
        },
        optionValue: {
            default: "name"
        },
        options: {
          default: function() {
            return [];
          }
        },
        columns: {
            default: 3
        }
    },
  computed: {
      toggleLabel() {
        return this.value.length === this.options.length ? 'Deselect all' : 'Select all';
      }
  },
    
    methods: {
        
        _optionName(option) {
            return option[this.optionValue];
        },
        
        _optionId(option) {
            return option[this.optionId];
        },
        
        has(option) {
          const id = this._optionId(option);
          const index = this.value.indexOf(id);
          return index > -1;

        },

        toggleAll() {
          if (this.value.length === this.options.length) {
            this.$emit('input', []);
            this.value = [];
          } else {
            this.$emit('input', this.options.map(option => this._optionId(option)));
            this.value = this.options.map(option => this._optionId(option));
          }
        },
        
        toggle(option) {
            const tempValue = this.value;
            const id = this._optionId(option);
            const index = tempValue.indexOf(id);
            if (index > -1) {
                tempValue.splice(index, 1);
            }
            else {
                tempValue.push(id);
            }
            this.$emit("input", tempValue);
        }
    }
}

</script>

<style>
button.select-all-toggle {
  border: 0;
  background: transparent;
  padding: 0;
  margin-bottom: 0.25em;
}
button.select-all-toggle:focus {
  box-shadow: none;
  border-color: transparent;
}

</style>
